(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lab-faq-cards"] && !Shopify.designMode) return;
  try {
    
  /**
   * FAQ a schede di `sections/lab-faq-cards.liquid` (custom element `<lab-faq-cards>`).
   *
   * Accordion esclusivo e non richiudibile: un clic (o Invio/Spazio sul pulsante) su una scheda la apre e
   * chiude tutte le altre; cliccare la scheda gia aperta non fa nulla. Stato nei markup: `data-open` sulla
   * scheda, `aria-expanded` / `aria-disabled` sul pulsante, `hidden` sul pannello. Quando l'editor del tema
   * ricarica la sezione il browser crea un nuovo elemento e `connectedCallback` lo reinizializza.
   */
  if (!customElements.get('lab-faq-cards')) {
    class LabFaqCards extends HTMLElement {
      /** @type {AbortController | null} */
      #abort = null;

      connectedCallback() {
        this.#abort = new AbortController();
        const { signal } = this.#abort;

        this.addEventListener('click', (event) => this.#onActivate(event), { signal });
        this.addEventListener('shopify:block:select', (event) => this.#onActivate(event), { signal });
      }

      disconnectedCallback() {
        this.#abort?.abort();
        this.#abort = null;
      }

      /**
       * Clic su una scheda (o selezione di un blocco nell'editor): la apre.
       * @param {Event} event
       */
      #onActivate(event) {
        if (!(event.target instanceof Element)) return;

        const item = event.target.closest('[data-lab-faq-item]');
        if (item instanceof HTMLElement && this.contains(item)) this.#open(item);
      }

      /** Apre la scheda e chiude tutte le altre. @param {HTMLElement} openItem */
      #open(openItem) {
        for (const item of this.querySelectorAll('[data-lab-faq-item]')) {
          if (item instanceof HTMLElement) this.#setState(item, item === openItem);
        }
      }

      /**
       * @param {HTMLElement} item
       * @param {boolean} open
       */
      #setState(item, open) {
        if ((item.dataset.open === 'true') === open) return;

        const button = item.querySelector('.lab-faq-cards__button');
        const panel = item.querySelector('.lab-faq-cards__answer');

        item.dataset.open = String(open);
        if (panel instanceof HTMLElement) panel.hidden = !open;

        if (button) {
          button.setAttribute('aria-expanded', String(open));

          // La scheda aperta non si puo richiudere: lo schema WAI-ARIA lo segnala con aria-disabled
          if (open) {
            button.setAttribute('aria-disabled', 'true');
          } else {
            button.removeAttribute('aria-disabled');
          }
        }
      }
    }

    customElements.define('lab-faq-cards', LabFaqCards);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
